module.exports = __webpack_public_path__ + "img/clickfunnels.1b075ccf.svg";